import { useState, useEffect } from 'react'
import DashboardMultiSelect from '../../../GlobalComponents/_misc/DashboardMultiSelect'
import { SalesDivision, SalesTeam } from '../../../features/salesperson/salespersonAPI'

interface SalesTeamMultiSelectProps {
    data: SalesDivision[]
    selectedValues: SalesTeam[]
    onSelectedValuesChanged(selectedValues: SalesTeam[]): void
}

const SalesTeamMultiSelect = (props: SalesTeamMultiSelectProps) => {
    const [salesTeams, setSalesTeams] = useState<SalesTeam[]>([])
    const [selectedValues, setSelectedValues] = useState<SalesTeam[]>(props.selectedValues)

    useEffect(() => {
        if (props.data.length === 0) return

        setSalesTeams([...new Set(props.data.map((item) => item.Team))].map((t) => ({ Team: t })))
    }, [props.data])

    const onChange = (value: SalesTeam[]) => {
        setSelectedValues(value)
        props.onSelectedValuesChanged(value)
    }

    return (
        <DashboardMultiSelect
            data={salesTeams}
            keyField="Team"
            textField="Team"
            selectedValues={selectedValues}
            onSelectedValuesChanged={onChange}
        />
    )
}

export default SalesTeamMultiSelect
